import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { obtenerCategoriaExtrasAction, addCategoriaExtraAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import FieldExtras from "../FieldExtras"
const FieldCatalogoExtras = () => {
    const { listaCategoriaExtras, categoriaExtra, clavePaquete } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerCategoriaExtrasAction({ ClavePaquete: clavePaquete }))
    }, [dispatch, clavePaquete])

    const handleChangeSelectValue = (event) => {
        dispatch(addCategoriaExtraAction({ categoriaExtra: event.target.value }))
    }
    // return <div style={{ margin: "2% 0" }}>
    //     <Grid container>
    //         <Grid item xs={12}>
    //             <FormControl variant="outlined" style={{ width: "98%" }}>
    //                 <InputLabel id="lExtras">Extras</InputLabel>
    //                 <Select
    //                     labelId="lExtras"
    //                     id="SExtra"
    //                     name="SExtra"
    //                     onChange={handleChangeSelectValue}
    //                     label="Extras"
    //                     value={categoriaExtra}
    //                 >
    //                     <MenuItem value="0" disabled>
    //                         {"Seleccione una opción"}
    //                     </MenuItem>
    //                     {listaCategoriaExtras.map((categoria, index) => (
    //                         <MenuItem key={categoria.idCatExtra} value={`${categoria.idCatExtra}`}>
    //                             {`${categoria.Descripcion}`}
    //                         </MenuItem>
    //                     ))}
    //                 </Select>
    //             </FormControl>
    //         </Grid>
    //     </Grid>
    // </div>
    return <div style={{ margin: "2% 0" }}>
        {listaCategoriaExtras.map((categoria, index) => (
            <div key={categoria.idCatExtra}>
                <FieldExtras idCategoriaExtra={categoria.idCatExtra} label={categoria.Descripcion} />
            </div>
        ))}
    </div>
}
export default FieldCatalogoExtras